<input type="text" [value]="getUrl()" disabled #input />
<button (click)="copy(input)">
  {{ (copiedState$ | async) ? 'Copié !' : 'Copier' }}
</button>
